<template>
  <v-btn
    color="white"
    height="48"
    :width="$vuetify.breakpoint.xs ? 280 : 340"
    :max-width="$vuetify.breakpoint.xs ? 280 : 340"
    class="font-weight-bold text-none d-flex align-center justify-center text-body-1"
    @click="login"
    :loading="loading"
  >
    <v-row class="ma-0 pa-0" no-gutters align="center" justify="center">
      <v-col cols="2" class="d-flex justify-end">
        <v-img
          :src="logo_microsoft"
          :width="$vuetify.breakpoint.xs ? 20 : 25"
          :height="$vuetify.breakpoint.xs ? 20 : 25"
          contain
          class="login-button-logo"
        />
      </v-col>
      <v-col class="font-montserrat"> {{ $t("action.loginMicrosoft") }} </v-col>
    </v-row>
  </v-btn>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LoginWithMicrosoft",

  data() {
    return {
      logo_microsoft: require("@/assets/images/logo_microsoft.png"),
      loading: false,
    };
  },

  methods: {
    ...mapActions(["callLoginMicrosoft"]),

    login() {
      this.loading = true;

      this.callLoginMicrosoft().finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.login-button-logo {
  mix-blend-mode: multiply;
}
</style>
